import React from "react";

const COLORS = {
  PENDING: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  QUEUED: { bg: "bg-sky-500/15", text: "text-sky-300", border: "border-sky-500/30", dot: "bg-sky-400" },
  RUNNING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30", dot: "bg-amber-400" },
  SUCCESS: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30", dot: "bg-rose-400" },
  CANCELLED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
};

const TYPE_LABELS = {
  INITIAL_INSTALL: "Initial",
  UPDATE: "Update",
  ROLLBACK: "Rollback",
  REBUILD: "Rebuild",
};

export function DeploymentStatusBadge({ status, size = "md" }) {
  const c = COLORS[status] || COLORS.PENDING;
  const sizeCls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  const dotCls = size === "sm" ? "w-1.5 h-1.5" : "w-2 h-2";
  const pulse = status === "RUNNING" || status === "QUEUED" ? "animate-pulse" : "";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${sizeCls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`deployment-status-${status.toLowerCase()}`}
    >
      <span className={`${dotCls} rounded-full ${c.dot} ${pulse}`} />
      {status}
    </span>
  );
}

export function DeploymentTypeBadge({ type, size = "md" }) {
  const label = TYPE_LABELS[type] || type;
  const sizeCls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border border-white/10 bg-white/5 text-white/70 font-bold ${sizeCls}`}
      data-testid={`deployment-type-${type?.toLowerCase()}`}
    >
      {label}
    </span>
  );
}
